// extracted by mini-css-extract-plugin
export default {"noteScreen":"LeadNotesTab_noteScreen__8SWm3"};